import { createUrlParserWrapper } from "./collection-filter/url-parser";

let urlParsersValue: UrlParsersValue | undefined;

interface UrlParsersValue {
    collections: ReturnType<typeof createUrlParserWrapper>;
}

export function createUrlParsers(): UrlParsersValue {
    if (urlParsersValue != null) return urlParsersValue;

    const collectionWrapper = createUrlParserWrapper();

    return (urlParsersValue = {
        collections: collectionWrapper,
    });
}
